import Button from '@/common/components/base/button/Button';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import useDebounce from '@/common/hooks/useDebounce';
import { getFileInsuranceQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/getFileInsurance/getFileInsuranceQueryOptions';
import { getOfficerListQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getOfficerList/getOfficerListQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';

export default ({
  open,
  closeModal,
  fieldRules,
  submitInquiry,
}: MainModalProps & {
  fieldRules: any;
  submitInquiry: (data: any) => void;
}) => (
  <MainModal open={open} closeModal={closeModal}>
    <PoliceReportInquiryModal
      fieldRules={fieldRules}
      closeModal={closeModal}
      submitInquiry={submitInquiry}
    />
  </MainModal>
);
const PoliceReportInquiryModal = ({
  closeModal,
  fieldRules,
  submitInquiry,
}: Pick<MainModalProps, 'closeModal'> & {
  fieldRules: any;
  submitInquiry: (data: any) => void;
}) => {
  const { id } = useParams();
  const methods = useForm();
  const [searchOfficer, setSearchOfficer] = useState({ code: '', name: '' });
  const debounce = useDebounce();
  const { data: fileInsurance } = useQuery(
    getFileInsuranceQueryOptions({ id: +id! }),
  );
  const { data: officerList } = useQuery(
    getOfficerListQueryOptions({
      insurance: fileInsurance?.code!,
      name: searchOfficer.name,
      code: searchOfficer.code,
    }),
  );
  const reportType = useWatch({
    name: 'police_report_type',
    control: methods.control,
  });
  const onSubmit = (data: any) => {
    submitInquiry(data.police_name_inquiry);
    closeModal();
  };
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ModalInput
          searchOptions={{
            label: 'جستجو',
            onChange: (value) => {
              debounce(() => setSearchOfficer({ code: value, name: '' }), 500);
            },
          }}
          name="police_report_code_inquiry"
          label="کد کارشناسی"
          placeholder="کد کارشناسی را وارد کنید"
          rules={{
            required: fieldRules(reportType)?.rules?.police_report_code,
          }}
          optionalLabel={!fieldRules(reportType)?.rules?.police_report_code}
          options={officerList?.code}
          onChange={(option) => {
            methods.setValue('police_name_inquiry', {
              label: option.value,
              value: option.label,
            });
          }}
        />
        <ModalInput
          searchOptions={{
            label: 'جستجو',
            onChange: (value) => {
              debounce(() => setSearchOfficer({ code: '', name: value }), 500);
            },
          }}
          name="police_name_inquiry"
          label="نام افسر"
          placeholder="نام افسر را وارد کنید"
          rules={{
            required: fieldRules(reportType)?.rules?.police_name,
          }}
          optionalLabel={!fieldRules(reportType)?.rules?.police_name}
          options={officerList?.name}
          onChange={(option) => {
            methods.setValue('police_report_code_inquiry', {
              label: option.value,
              value: option.label,
            });
          }}
        />
        <Button
          // onClick={methods.handleSubmit(onSubmit)}

          fullWidth
        >
          ثبت و ادامه
        </Button>
      </form>
    </FormProvider>
  );
};
